export default __webpack_public_path__ + "static/media/Slider-3.889dc8a0.jpeg";